<template>
  <el-select :value="value" filterable :filter-method="handleFilter" :placeholder="placeholder" @change="handleInput" :clearable="true">
    <el-option
      v-for="item in activeItems"
      :key="item.id"
      :label="item.name"
      :value="item.id">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'TypeSelect',
  props: {
    value: Number,
    cid: Number,
    level: Number,
    placeholder: {
      type: String,
      default: '题型'
    }
  },
  data () {
    return {
      items: [],
      activeItems: [],
    }
  },
  computed: {
    courseId() {
      return this.cid || this.$store.state.currentCourseId;
    }
  },
  created () {
    this.initItems()
  },
  watch: {
    courseId () {
      this.initItems()
    },
    level () {
      this.initItems()
    }
  },
  inject: {
    api_list: {
      default: '',
    },
    api_params: {
      default: null
    }
  },
  methods: {
    initItems () {
      if (this.level !== null && this.level !== undefined) {
        return this.$http.get(this.api_list || this.$urls.exercise_type_list, {
          params: { 
            'filter[course_id]': this.courseId,
            'filter[level]': this.level,
            'sort': 'name',
            page: 1, 
            'per-page': 1000,
            ...this.api_params
          }
        }).then(res => {
          this.activeItems = this.items = res.data
        })
      } else {
        this.activeItems = this.items = []
      }
    },
    handleInput (val) {
      this.$emit('input', val)
    },
    handleFilter(query) {
      if (query) {
        const reg = new RegExp(query, 'i');
        this.activeItems = this.items.filter(n => reg.test(n.name) || reg.test(n.template));
      } else {
        this.activeItems = this.items
      }
    }
  }
}
</script>
